<template>
	<div class="box-wrapper" :class="{ large: size === 'large' }" @click="routeToBrandDetail">
		<img :src="item.image ? item.image : require('@/assets/images/no-image-small.jpg')" :style="{ width: item.image ? '' : '170px' }" />
	</div>
</template>

<script>
import PageName from '@/utils/define/PageName'

export default {
	name: 'MainBoxItem',
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		type: {
			type: String,
			default: '',
		},
		// '' (기본, 메인 페이지) | 'large' (브랜드관)
		size: {
			type: String,
			default: '',
		},
	},
	methods: {
		routeToBrandDetail() {
			// 브랜드 타입일 경우 search/brand?id={id} 로 이동
			if (this.type === 'brand') {
				this.$router.push({
					path: '/search/brand',
					query: {
						id: this.item.id,
					},
				})
			} else {
				// 기존 로직 (판매자 등)
				this.$router.push({
					name: PageName.Search,
					params: {
						category: this.type,
					},
					query: {
						id: this.item.id,
					},
				})
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.box-wrapper {
	border: 1px solid #eeeeee;
	border-radius: 10px;
	width: 170px;
	height: 60px;
	cursor: pointer;
	display: flex;
	justify-content: center;
	padding: 0 21px;
	position: relative;
	overflow: hidden;
	&:hover {
		outline: solid 5px #fff5dd;
	}
	/* 브랜드관용 큰 사이즈 (기본 170x60) */
	&.large {
		width: 200px;
		height: 80px;
		padding: 0 24px;
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	input[type='checkbox'] {
		position: absolute;
		bottom: 15px;
		right: 15px;
		&.wish {
			&:after {
				top: -10px;
				left: -10px;
			}
		}
	}
}

/* 모바일: 칸 폭을 채운다 */
html.is-mobile .box-wrapper,
html.is-mobile .box-wrapper.large {
	width: auto;
	height: 66px;
	padding: 0 16px;
}
</style>
